<template>
  <div class="grid-layout__container" :style="{ height: `${layoutHeight}px` }">
    <preview-slot
      v-for="(widget, index) in slots"
      :ref="`slot-${widget.pos}`"
      :key="index"
      :index="index"
      :widget="widget"
      :slots="slots"
      :close-icon="closeIcon"
      :layout-items="layoutItems"
      :style="{ ...gridItemStyles(widget) }"
      @select-slot="selectSlot"
      @unset-slot="unselectSlot"
    />
  </div>
</template>

<script>
import { onMounted, reactive, computed, toRefs, watch } from "@vue/composition-api";
import store from "@/store";
import useLayout from "@/composables/layouts";
import PreviewSlot from "./PreviewSlot";

export default {
  components: { PreviewSlot },
  props: {
    closeIcon: {
      type: Boolean,
      default: true
    },
    selectedLayout: {
      required: true,
      type: String | Number,
    },
    slotHeight: {
      type: Number,
      default: 55
    },
    layoutItems: {
      type: Array,
      default: null
    }
  },
  setup(props, { emit,refs }) {
    //DATA
    const state = reactive({ slots: [] });

    //COMPUTED
    const layoutHeight = computed(() => {
      if (!state.slots.length) return 0;

      const maxRow = Math.max(...state.slots.map(s => s.y + s.h));

      return maxRow * props.slotHeight;
    });

    const layout = computed(() => {
      const userLayouts = store.getters["layouts/getUserLayouts"];
      return userLayouts.find((l) => l.id === props.selectedLayout);
    });

    const { gridItemStyles } = useLayout(props.selectedLayout, props.slotHeight);

    //METHODS
    const checkSlots = (slotData) => {
      const slotWithoutData = state.slots.find(slot => {
        if (!slot.data) {
          return slot;
        }

        const slotObjectEntries = Object.entries(slot.data);
        const slotObejectHasProperties = slotObjectEntries.length;

        if (slotObejectHasProperties) {
          return false;
        }

        return slot;
      });

      if (slotWithoutData) {
        setSlot(slotWithoutData, slotData);
      }
    }

    const checkSlotsEdit = (slotData, indexSlotEdit) => {
      if (slotData.data) {
        const slot = state.slots[indexSlotEdit];

        setSlot(slot, slotData, 'checkSlotsEdit');
      }
    }

    const findSlotWithoutData = (slotData, isEdit = false, indexSlotEdit = null) => {
      if (isEdit) {
        checkSlotsEdit(slotData, indexSlotEdit);
        return;
      }

      checkSlots(slotData);
    }

    const setGrid = () => {
      if (!layout.value || !layout.value.grid) {
        state.slots = [];
        return;
      }
      const grid = JSON.parse(JSON.stringify(layout.value.grid));
      state.slots = grid;

      emit('get-user-layouts-finish');
      /* emit('set-grid'); */
    };

    const selectSlot = (slots) => {
      emit('select-slot', slots)
    }

    const setSlot = (slot, slotData, origen) => {
      const { pos } = slot;
      const [refPreviewSlot] = refs[`slot-${pos}`];

      store.dispatch('alarm_views/setSlotData', slotData);
      refPreviewSlot.onSelectSlot(pos);
    }

    const unselectSlot = (slots, widget) => {
      emit('unselect-slot', slots, widget)
    }

    watch(
      () => props.selectedLayout,
      () => setGrid()
    );

    onMounted(async () => {
      await store.dispatch("layouts/getUserLayouts");
      setGrid();
    });

    return {
      gridItemStyles,
      ...toRefs(state),
      layout,
      layoutHeight,

      findSlotWithoutData,
      selectSlot,
      unselectSlot
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
